module.exports = __webpack_public_path__ + "static/media/user-edit-image.8a844cbd.svg";